module.exports = __webpack_public_path__ + "static/media/order_icon30.328b0f7c.png";